import { softDeleteDocument, hardDeleteDocument } from 'api/documents'
import DialogBase from 'components/dialog/Base'
import { DocListItem } from 'entities/Documents'
import { useState } from 'react'

type Props = {
  open: boolean
  setOpenDialog: (x: boolean) => void
  documents?: DocListItem[]
  selectedIDs: string[]
  reloadDocs?: (ids: string[]) => void
  hard?: boolean
}

const DEFAULT_STAUS = {
  success: undefined,
  message: '',
}

const DelDocDialog = ({ open, setOpenDialog, documents, selectedIDs, reloadDocs, hard }: Props) => {
  const multi = documents // it's multi(from list) if documents exists

  const text = {
    title: hard ? '削除' : '移動',
    content: `${multi ? '選択したファイル' : 'ファイル'}${
      hard ? 'を完全に削除しますか？' : 'をごみ箱へ移動しますか？'
    }`,
    success: hard ? '削除しました' : '移動しました',
    failed: hard ? '削除に失敗しました' : '移動に失敗しました',
    back: '戻る',
  }
  //  const params = useSelector(selectParams)

  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState<{ success: boolean | undefined; message: string }>(
    DEFAULT_STAUS,
  )
  const sent = status.success !== undefined

  const close = () => {
    setOpenDialog(false)
    // keep status until close animation is done
    setTimeout(() => setStatus(DEFAULT_STAUS), 1000)
  }

  const submit = async () => {
    setLoading(true)

    const { data } = await (hard
      ? hardDeleteDocument(selectedIDs)
      : softDeleteDocument(selectedIDs))
    const success = data?.message === 'OK'
    setStatus({ success, message: success ? text.success : text.failed })

    setLoading(false)
  }

  const back = () => {
    close()
    if (reloadDocs) {
      reloadDocs(selectedIDs)
    }
  }

  return (
    <DialogBase
      open={open}
      onCancel={sent ? undefined : close}
      onAction={sent ? (status.success ? back : close) : submit}
      actionText={sent && status.success && !multi ? text.back : undefined}
      loading={loading}
    >
      {status.message || text.content}
    </DialogBase>
  )
}

export default DelDocDialog
